module.exports = __webpack_public_path__ + "media/images/favicon-98cf244396bcfccc64e70cb651fcd88f.png";